export type {PhoneProps as InputProps} from './Phone.type';
export {Phone} from './Phone';
